import React, {useCallback, useEffect, useState} from 'react';
import Autocomplete from '@material-ui/lab/Autocomplete';
import TextField from '@material-ui/core/TextField';
import {debounce} from 'lodash';
import axios from "axios";
import {AUTOCOMPLETE_SEARCH, SERVER_URL} from "../../../services/Config";


const AutocompleteWithDebounce = ({updateIds,database}) => {
    const [options, setOptions] = useState([]);
    const [inputValue, setInputValue] = useState('');
    const [selectedOptions, setSelectedOptions] = useState([]);
    const [curDatabase,setCurDatabase] = useState(database)

    useEffect(() => {
        setCurDatabase(database)
    }, [database]);

    const formatOptionString = (id, description) => {
        // Assuming a fixed width for the ID
        // const idWidth = 10;
        // const formattedId = id.padEnd(idWidth, ' ');
        // return `${formattedId} --- ${description}`;
        return `${id} --- ${description}`;
    };

    // Function to simulate API call
    const fetchOptions = (input) => {

        const formData = new FormData();
        formData.append("query", input)
        formData.append("db", curDatabase)
        formData.append("limit_prefix",'PF')

        axios
            .post(SERVER_URL + AUTOCOMPLETE_SEARCH, formData)
            .then((response) => {

                let autocompleteOptions = response.data.map((curItem,index)=>{
                    return formatOptionString(curItem.Id, curItem.description)
                })

                setOptions(autocompleteOptions);


            })
            .catch((e) => {
                console.log('Annotool search error')
                console.log(e)
            });

    };

    // Debounced fetchOptions
    // const debouncedFetchOptions = debounce(fetchOptions, 500);


    const debouncedFetchOptions = useCallback(
        debounce((input) => fetchOptions(input), 750),
        [] // Dependencies array, empty to create the function only once
    );

    useEffect(() => {
        if (inputValue) {
            debouncedFetchOptions(inputValue);
        } else {
            setOptions([]);
        }
    }, [inputValue, debouncedFetchOptions]);

    return (
        <Autocomplete
            freeSolo
            multiple
            options={options}
            value={selectedOptions}
            onChange={(event, newValue) => {
                setSelectedOptions(newValue);
                updateIds(newValue)
            }}
            onInputChange={(event, newInputValue) => {
                setInputValue(newInputValue);
                // updateInputValue(newInputValue);
            }}
            renderInput={(params) => (
                <TextField
                    {...params}
                    label="Please enter single Pfam ID or Pfam IDs "
                    variant="outlined"
                    value={selectedOptions.join(', ') + (selectedOptions.length > 0 ? ', ' : '') + inputValue}
                />
            )}
        />
    );
};

export default AutocompleteWithDebounce;
